import { useEffect, useState } from "react";
import Lenis from "lenis";
import api from "@/api";
import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { ServicesCatalog } from "@/components/ServicesCatalog";
import { BeforeAfterGallery } from "@/components/BeforeAfterGallery";
import { Manifesto } from "@/components/Manifesto";
import { BookingFlow } from "@/components/BookingFlow";
import { Testimonials } from "@/components/Testimonials";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  const [services, setServices] = useState([]);
  const [slots, setSlots] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [selectedService, setSelectedService] = useState("");

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  useEffect(() => {
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
    api.get("/time-slots").then((r) => setSlots(r.data)).catch(() => {});
    api.get("/gallery").then((r) => setGallery(r.data)).catch(() => {});
  }, []);

  const handleSelectService = (slug) => {
    setSelectedService(slug);
    document.getElementById("booking")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="bg-[#0B0F17] text-slate-100 min-h-screen">
      <Header />
      <main>
        <Hero />
        <EditorialMarquee />
        <ServicesCatalog services={services} onSelect={handleSelectService} />
        <BeforeAfterGallery items={gallery} />
        <Manifesto />
        <Testimonials />
        <BookingFlow services={services} slots={slots} selectedService={selectedService} onSelectService={setSelectedService} />
      </main>
      <Footer />
    </div>
  );
}
